import React from "react"

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import ProductIcon from '../../../../images/carta_certificada.png'
import '../../../../custom.css'

import { GridProductImgStyled } from "../../../common/outbox/product/ProductSelectorStyled"

/**
 * Represents one of the available product types for selection.
 */
export class ProductSelector extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  /**
   * Handler click event to send to parent component state the product selected
   */
  handleClickProduct = (event) => {
    let productCode = event.target.closest("div.product-container").id
    this.props.handleSelectProduct(productCode)
  }

  render() {
    const selectedClass = this.props.active === true ? "selected-element" : "no-selected-element"

    return (
      <Grid id={this.props.productCode} item md={3} className={selectedClass + " product-container m-10"} onClick={this.handleClickProduct}>
        <Grid container direction="row">
          <GridProductImgStyled item md={3}>
            <img src={ProductIcon} alt="" style={{ width: 40 }}></img>
          </GridProductImgStyled>
          <Grid item md={9}>
            <Typography className="typography-generic product-description font-weight-bold" variant="subtitle1">
              {this.props.description}
            </Typography>
            <Typography className="typography-generic product-description small" variant="subtitle2">
              {this.props.subtitle}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default ProductSelector


// WEBPACK FOOTER //
// ./src/components/shipments/sections/product/ProductSelector.js